import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { BROADCAST_URL } from '~/utils/constants'
import { getAuthCookie } from '~/utils/auth-cookie'

/**
 * Laravel Echo (Pusher)
 */
const getAuthorizationHeader = (): string => {
  const token = getAuthCookie()
  return token ? `Bearer ${token}` : ''
}

const laravelEcho = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY || 'app-key',
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'app-cluster',
  wsHost: import.meta.env.VITE_PUSHER_APP_HOST || 'localhost',
  wsPort: import.meta.env.VITE_PUSHER_APP_PORT || 6001,
  wssPort: import.meta.env.VITE_PUSHER_APP_PORT || 6001,
  forceTLS: false,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  namespace: 'App\\Events\\Broadcast',
  authEndpoint: BROADCAST_URL,
  auth: {
    headers: {
      Authorization: getAuthorizationHeader(),
    },
  },
})

if (import.meta.env.DEV) {
  Pusher.logToConsole = true
}

const updateEchoAuthHeader = (token: string | null): void => {
  const value = token ? `Bearer ${token}` : ''

  if (laravelEcho.options.auth?.headers) {
    laravelEcho.options.auth.headers.Authorization = value
  }

  const connector = laravelEcho.connector as {
    pusher?: { config: { auth: { headers: Record<string, string> } } }
  }

  if (connector?.pusher?.config?.auth?.headers) {
    connector.pusher.config.auth.headers.Authorization = value
  }
}

export { laravelEcho, Pusher, updateEchoAuthHeader }
